<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :export-file-name="priceUtil.getFileName(fileName)"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'ShippingScheduleDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '220500' },
    showBranch: { type: Boolean, default: true },
    showCreate: { type: Boolean, default: true },
    showModify: { type: Boolean, default: true },
    showApprove: { type: Boolean, default: false },
    showCheckBox: { type: Boolean, default: true },
    showBasicInfo: { type: Boolean, default: true },
    fileName: { type: String, default: 'SailingSchedule' },
    filter: { type: Object, default: () => {} },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      priceUtil: PriceUtils,
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', checkboxSelection: true,
          hide: !this.showCheckBox, suppressColumnsToolPanel: !this.showCheckBox,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          hide: !this.showBasicInfo, suppressColumnsToolPanel: !this.showBasicInfo,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          hide: !this.showBasicInfo, suppressColumnsToolPanel: !this.showBasicInfo,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('Pricing.TransferPort'), field: 'transferPort', colId: 'transferPort', width: 200,
          hide: !this.showBasicInfo, suppressColumnsToolPanel: !this.showBasicInfo,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('Pricing.Dockland'), field: 'dockland', colId: 'dockland', width: 200 },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          hide: !this.showBasicInfo, suppressColumnsToolPanel: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
          valueFormatter: params => {
            return String(params.value) + ' '
          }
        },
        {
          headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200,
          valueFormatter: params => {
            return String(params.value) + ' '
          }
        },
        { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200,
          valueFormatter: params => {
            return params.value > 0 ? params.value : ''
          }
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
    }
  }
}
</script>
<style lang="scss">
</style>

